<template>
  <article class="wagb-pc">
    <div class="wagb-pc__lead">
      <!-- 导语 -->
      <div class="wagb-pc__intro">
        <p v-for="(block, idx) in intro.paragraphs" :key="idx">
          <template v-if="typeof block === 'string'">{{ block }}</template>
          <template v-else>
            {{ block.textBefore
            }}<router-link :to="block.linkTo">{{ block.linkText }}</router-link>{{ block.textAfter }}
          </template>
        </p>
      </div>

      <router-link :to="intro.ctaLink" class="wagb-pc__cta">
        👉 {{ intro.cta }}
      </router-link>

      <!-- 真实内容图：content/14-pc-hero.webp -->
      <figure class="wagb-pc__figure wagb-pc__figure--photo">
        <img
          :src="images.hero"
          alt="Unduh GB WhatsApp untuk PC"
          width="960"
          height="540"
          loading="eager"
        />
      </figure>
    </div>

    <!-- Apa itu -->
    <section :id="sections.whatIs.id" class="wagb-pc__section">
      <h2>{{ sections.whatIs.title }}</h2>
      <p v-for="(para, idx) in sections.whatIs.paragraphs" :key="idx">{{ para }}</p>
    </section>

    <!-- Cara Menggunakan -->
    <section :id="sections.methods.id" class="wagb-pc__section">
      <h2>{{ sections.methods.title }}</h2>
      <p>{{ sections.methods.intro }}</p>

      <article
        v-for="method in sections.methods.items"
        :key="method.id"
        :id="method.id"
        class="wagb-pc__method"
      >
        <h3>{{ method.title }}</h3>
        <p v-if="method.descHtml">
          Emulator seperti BlueStacks, LDPlayer, atau NoxPlayer memungkinkan kamu menjalankan
          <strong>WA GB APK</strong> langsung di PC seperti di smartphone.
        </p>
        <p v-else>{{ method.desc }}</p>
        <p class="wagb-pc__steps-label">{{ method.stepsLabel }}</p>
        <ul class="wagb-pc__list">
          <li v-for="step in method.steps" :key="step">{{ step }}</li>
        </ul>
      </article>
    </section>

    <!-- Kelebihan -->
    <section :id="sections.advantages.id" class="wagb-pc__section">
      <h2>{{ sections.advantages.title }}</h2>
      <p>{{ sections.advantages.intro }}</p>
      <ul class="wagb-pc__list wagb-pc__list--check">
        <li v-for="item in sections.advantages.items" :key="item">{{ item }}</li>
      </ul>
    </section>

    <!-- Informasi Singkat -->
    <section :id="sections.info.id" class="wagb-pc__section">
      <h2>{{ sections.info.title }}</h2>
      <ul class="wagb-pc__list wagb-pc__info-list">
        <li v-for="row in sections.info.rows" :key="row.label">
          <strong>{{ row.label }}:</strong> {{ row.value }}
        </li>
      </ul>
    </section>

    <!-- Catatan Penting -->
    <section :id="sections.notice.id" class="wagb-pc__section">
      <h2>{{ sections.notice.title }}</h2>
      <div class="wagb-pc__notice">
        <p v-for="(para, idx) in sections.notice.paragraphs" :key="idx">{{ para }}</p>
      </div>
    </section>

    <!-- Masalah -->
    <section :id="sections.problems.id" class="wagb-pc__section">
      <h2>{{ sections.problems.title }}</h2>
      <p>{{ sections.problems.intro }}</p>
      <ul class="wagb-pc__list">
        <li v-for="item in sections.problems.items" :key="item">{{ item }}</li>
      </ul>
      <p class="wagb-pc__tip">👉 {{ sections.problems.tip }}</p>
    </section>

    <!-- Kesimpulan -->
    <section :id="sections.conclusion.id" class="wagb-pc__section">
      <h2>{{ sections.conclusion.title }}</h2>
      <p>{{ sections.conclusion.text }}</p>
    </section>
  </article>
</template>

<script>
import '@/css/wagbappro-pc.scss';
import {
  images,
  intro,
  sections,
} from '@/data/wagbappro/pc-id';

export default {
  name: 'PcContentId',
  data() {
    return {
      images,
      intro,
      sections,
    };
  },
};
</script>
